export const getLocalStartOfWeek = () => {
  const locale = Intl.DateTimeFormat().resolvedOptions().locale || 'en-US'
  const mondayStartLocales = [
    'en-GB', // English (United Kingdom)
    'de-DE', // German (Germany)
    'fr-FR', // French (France)
    'es-ES', // Spanish (Spain)
    'it-IT', // Italian (Italy)
    'nl-NL', // Dutch (Netherlands)
    'pt-PT', // Portuguese (Portugal)
    'da-DK', // Danish (Denmark)
    'sv-SE', // Swedish (Sweden)
    'fi-FI', // Finnish (Finland)
    'no-NO', // Norwegian (Norway)
    'pl-PL', // Polish (Poland)
    'cs-CZ', // Czech (Czech Republic)
    'sk-SK', // Slovak (Slovakia)
    'hu-HU', // Hungarian (Hungary)
    'ro-RO', // Romanian (Romania)
    'tr-TR', // Turkish (Turkey)
    'he-IL', // Hebrew (Israel)
    'ar-SA', // Arabic (Saudi Arabia)
    'ru-RU', // Russian (Russia)
    'bg-BG', // Bulgarian (Bulgaria)
    'hr-HR', // Croatian (Croatia)
    'sr-RS', // Serbian (Serbia)
    'lt-LT', // Lithuanian (Lithuania)
    'lv-LV', // Latvian (Latvia)
    'et-EE', // Estonian (Estonia)
    'sl-SI', // Slovenian (Slovenia)
    'mk-MK', // Macedonian (North Macedonia)
    'bg-BG', // Bulgarian (Bulgaria)
    'sq-AL', // Albanian (Albania)
    'el-GR', // Greek (Greece)
    'uk-UA', // Ukrainian (Ukraine)
    'ka-GE', // Georgian (Georgia)
  ]

  const isMondayStart = mondayStartLocales.some((code) => locale === code)
  const startOfWeek = isMondayStart ? 1 : 0

  return startOfWeek
}
